import React, { useEffect, useState } from 'react';
import styles from './perfilesUsuario.module.css';
import { useSelector, useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Spinner, Button } from 'react-bootstrap';
import { obtenerDatosUsuarios, deleteUsuario, updateUsuario, createUsuario, obtenerEspecialidades } from '../../services/firebase/perfilesUsuarios';
import { obtenerPerfilesCreados } from '../../services/firebase/perfiles/index';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { usiarioUploadImage } from "../../services/firebase/usuarios/index";

import ConfirmacionSiNoModal from '../../components/ConfirmacionSiNoModal';
import EditUserModal from './Modales/EditarModal';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import PeopleIcon from "@material-ui/icons/People";

export const PerfilesUsuarios = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [lsUsuario] = useLocalStorage('usuario');
    const empresa = useSelector((state) => state.empresa)
    const [usuariosFirebase, setUsuariosFirebase] = useState([]);
    const [perfilesList, setPerfilesList] = useState([]);
    const [especialidades, setEspecialidades] = useState({});
    const membresia = empresa.membresia
    const [showModalEliminar, setShowModalEliminar] = useState(false)
    const [showModalEditar, setShowModalEditar] = useState(false)
    const dispatch = useDispatch();
    
    const perfileOdontologo = ["ODONTOLOGO", "ODONTOLOGO_ADM"]

    const [formData, setFormData] = useState({
        id: '',
        nombres: '',
        email: '',
        especialidad: '',
        cop: '',
        uid: '',
        perfil: '',
        empresaId: '',
        biografia: '',
        foto: '',
        firma: ''
    });
    
    const { addToast } = useToasts();

    const usuariosDatos = async () => {
        try {
            if (empresa.id) {
                const usuariosData = await obtenerDatosUsuarios(empresa.id);
                setUsuariosFirebase(usuariosData);
            }
        } catch (error) {
            console.error('Error al obtener datos de Firebase:', error);
        }
    };

    useEffect(() => {
        setIsLoading(true)
        usuariosDatos().finally(() => setIsLoading(false));
    }, [empresa.id]);

    useEffect(() => {
        const fetchPerfiles = async () => {
            try {
                const perfiles = await obtenerPerfilesCreados();
                setPerfilesList(perfiles);
            } catch (error) {
                console.error('Error al obtener perfiles:', error);
            }
        };
        const fetchEspecialidades = async () => {
            try {
                const esp = await obtenerEspecialidades();
                setEspecialidades(esp);
            } catch (error) {
                console.error('Error al obtener especialidades:', error);
            }
        };
        fetchPerfiles();
        fetchEspecialidades();
    }, []);

    const onFileChange = async (e) => {
        try {
            const file = e.target.files[0];
            const fieldName = e.target.name || 'foto';
            
            if (file) {
                addToast('Subiendo imagen...', { appearance: 'info', autoDismiss: true });
                const fileUrl = await usiarioUploadImage(file);
                if (fileUrl) {
                    setFormData(prevData => ({ ...prevData, [fieldName]: fileUrl }));
                    addToast('Imagen cargada correctamente', { appearance: 'success', autoDismiss: true });
                }
            }
        } catch (error) {
            addToast('Error al cargar la imagen', { appearance: 'error', autoDismiss: true });
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: value }));
    }
    
    const handleClearForm = () => {
        setFormData({
            id: '', nombres: '', email: '', especialidad: '', cop: '',
            uid: '', firma: '', perfil: '', empresaId: empresa.id,
            biografia: '', foto: '',
        });
    };

    const handleSaveUser = async () => {
        try {
            let mensaje = ''
            let usrDb = { ...formData, empresaId: empresa.id }
            
            if (usrDb.id) {
                await updateUsuario(usrDb)
                mensaje = 'Usuario actualizado correctamente'
            } else {
                await createUsuario(usrDb);
                mensaje = 'Usuario creado correctamente'
            }

            await usuariosDatos();
            setShowModalEditar(false);
            addToast(mensaje, { appearance: 'success', autoDismiss: true });
        } catch (error) {
            addToast(error.message, { appearance: 'error', autoDismiss: true });
        }
    };

    const handleEditUser = (usuario) => {
        setFormData({ ...usuario })
        setShowModalEditar(true)
    };

    const handleDeleteUser = (usuario) => {
        setFormData({ ...usuario })
        setShowModalEliminar(true)
    };

    const handleNewUser = () => {
        handleClearForm()
        setShowModalEditar(true)
    };
    
    const handleSaveDeleteUser = async () => {
        try {
            await deleteUsuario(formData);
            const updatedUsuarios = usuariosFirebase.filter(user => user.id !== formData.id);
            setUsuariosFirebase(updatedUsuarios);
            setShowModalEliminar(false);
            addToast('Usuario eliminado correctamente', { appearance: 'success', autoDismiss: true });
        } catch (error) {
            console.error('Error al eliminar usuario:', error);
        }
    };

    const isAdmin = lsUsuario?.perfil === 'ODONTOLOGO_ADM';

    if (isLoading || membresia == null)
        return <div className="p-5 text-center"><Spinner animation="border" /></div>;

    return (
        <div className={styles.mainContainer}>
            <div className="d-flex justify-content-between align-items-end mb-4">
                <div>
                  <h3 className={styles.titleHeader}>Equipo de Trabajo</h3>
                  <p className="text-muted mb-0">Gestiona los especialistas y el personal de tu consultorio.</p>
                </div>
                {isAdmin && (
                    <Button className={styles.addNewButton} onClick={handleNewUser}>
                        + Nuevo Integrante
                    </Button>
                )}
            </div>

            <div className={styles.userCards}>
                {usuariosFirebase.map((usr) => {
                    const profileImage = usr.foto || usr.firma;
                    const roleClass = perfileOdontologo.includes(usr.perfil) ? styles.badgeODONTOLOGO : styles.badgeADMINISTRATIVO;
                    
                    return (
                        <div key={usr.id} className={styles.userCard}>
                            <div className={`${styles.roleBadge} ${roleClass}`}>
                                {usr.perfil}
                            </div>
                            
                            <div className={styles.imageWrapper}>
                                {profileImage ? (
                                    <img src={profileImage} alt={usr.nombres} className={styles.profileImage} />
                                ) : (
                                    <div className={styles.imagePlaceholder}>
                                        <PeopleIcon style={{ fontSize: '50px' }} />
                                    </div>
                                )}
                            </div>

                            <div className={styles.userInfo}>
                                <span className={styles.userName}>{usr.nombres}</span>
                                <span className={styles.userRole}>{usr.especialidadLabel || usr.especialidad || usr.perfil}</span>
                                <p className={styles.biografiaSnippet}>
                                    {usr.biografia || "Sin biografía profesional registrada."}
                                </p>
                            </div>

                            {isAdmin && (
                                <div className={styles.actions}>
                                    <Tooltip TransitionComponent={Zoom} placement="top" title="Editar">
                                        <IconButton className={styles.actionButton} onClick={() => handleEditUser(usr)}>
                                            <EditIcon style={{ color: "#0C8DE3" }} />
                                        </IconButton>
                                    </Tooltip>

                                    {usr.email !== lsUsuario?.email && (
                                        <Tooltip TransitionComponent={Zoom} placement="top" title="Eliminar">
                                            <IconButton className={styles.actionButton} onClick={() => handleDeleteUser(usr)}>
                                                <DeleteIcon style={{ color: "#ef4444" }} />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            <ConfirmacionSiNoModal
                mensaje="¿Está seguro que desea eliminar este usuario?"
                isOpen={showModalEliminar}
                handleCloseModal={() => setShowModalEliminar(false)}
                onClickYes={handleSaveDeleteUser} />

            <EditUserModal
                formData={formData}
                isOpen={showModalEditar}
                handleCloseModal={() => setShowModalEditar(false)}
                handleSaveUser={handleSaveUser}
                handleInputChange={handleInputChange}
                onFileChange={onFileChange}
                perfilesList={perfilesList}
                especialidades={especialidades}
            />
        </div>
    );
};